import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import {
	changeCurrentPath,
	fetchConsigneeList,
	resetConsigneeListState,
	getPdfItemsConsignee,
	clearPdfItemsConsignee,
	updateConsigneeFlag,
	undoConsigneeFlag,
	resetMainListState,
	resetConsigneeListStateNew,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';


import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';



import {DatePicker}from 'material-ui-pickers';
import PdfViewer from '../../common/components/viewer/pdf-viewer';
import AlertDialog from '../../common/components/dialog/alert-dialog';

const columns = [
	{ name: 'SelectionReplaceButton', title:' ' ,width:20},
	{ name: 'NiukeshoStatusName', title: 'ステータス',width:150 },
	{ name: 'NinushiTorihikiName', title: '取引名称' ,width:100},
	{ name: 'NohinYoteiYMD', title: '納品日',width:135 },
	{ name: 'OtodokesakiName', title: '納品先名称',width:200 },
	{ name: 'OtodokesakiAddress', title: '納品先住所' ,width:400},
	{ name: 'NinushiName', title: '荷主名',width:200 },
	{ name: 'DenpyoNO', title: '伝票番号' ,width:150},
];

const numberColumns = ['TorikomiCount','DenpyoMaisu'];


const styles = theme => ({
	datePicker : {
		marginTop : '-7px',
		width:'150px'
	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontFamily:'Noto Sans JP'
	},
	expands : {
		boxShadow:'initial'
	}
});


class ConsigneeList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows : [],
			dateType : this.props.settings.dateType,
			selectedDateFrom:this.props.settings.selectedDateFrom,
			selectedDateTo:this.props.settings.selectedDateTo,
			selections:this.props.settings.selections,
			sorts : this.props.settings.sorts,
			dialogOpen : false,
			dialogOpenUndo:false,
			undoRow : {}
        };


    }
    /** override methods **/
	UNSAFE_componentWillMount(){
    	this.handleClickSumup();
		const {dispatch} = this.props;
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const { dispatch} = this.props;
		dispatch(resetConsigneeListState());
	}


    /** event handlers **/
	handleDateTypeChange = event => {
		this.setState({ dateType: event.target.value });
	};
	handleDateFromChange = date => {
		let selectedDateTo = this.state.selectedDateTo;
		if(selectedDateTo){
			const dateDiff = selectedDateTo.diff(date,'days');
			if(dateDiff < 0) {
				selectedDateTo = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateTo = new moment(date);
				selectedDateTo.add(14,'days');
			}
		}
		this.setState({
			selectedDateFrom: date,
			selectedDateTo
		});
	};
	handleDateFromInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateFrom: null });
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.selectedDateFrom;
		if(selectedDateFrom){
			const dateDiff = date.diff(selectedDateFrom,'days');
			if(dateDiff < 0) {
				selectedDateFrom = new moment(date);
			}
			else if(dateDiff > 14){
				selectedDateFrom = new moment(date);
				selectedDateFrom.add(-14,'days');
			}
		}
		this.setState({
			selectedDateFrom,
			selectedDateTo: date
		});
	};
	handleDateToInputChange = (e) =>{
		if(!e.target.value) this.setState({ selectedDateTo: null });
	};
	handleSelectionChange = selections => {
		this.setState({
			selections
		});
	};
	handleSortOrderChange = (sorts) =>{
		this.setState({
			sorts
		});
	};
	handleClickSumup = event => {
		const {dispatch} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = this.state;
		this.setState({
			selections:[]
		});
		dispatch(fetchConsigneeList({
			dateType,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : this.props.auth.SessionID
		}));
	};
	handleClickSave = event => {
		this.setState({
			dialogOpen : true
		});
	};
	handleClickSlipNo = (row) =>{
		const {dispatch,auth} = this.props;
		const selections = [row["id"]];
		dispatch(getPdfItemsConsignee({
			selections,
			SessionID:auth.SessionID
		}));
	};

	afterCloseFunc = () => {
		const { dispatch} = this.props;
		dispatch(clearPdfItemsConsignee());
	};

	doUpdate = () =>{
		this.setState({
			dialogOpen:false
		});

		const { dispatch,auth} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = this.state;
		const selections = this.state.selections.map(selection=>{
			return selection["id"];
		});
		dispatch(updateConsigneeFlag({
			dateType,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : auth.SessionID,
			selections
		}));

	};

	cancelUpdate = () =>{
		this.setState({
			dialogOpen:false
		});
	};

	handleClickUndo = (row) =>{
		this.setState({
			dialogOpenUndo:true,
			undoRow:row
		});
	};

	doUndo = () =>{
		this.setState({
			dialogOpenUndo:false
		});
		const { dispatch,auth} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = this.state;
		dispatch(undoConsigneeFlag({
			dateType,
			selectedDateFrom : !(selectedDateFrom) ? null : moment(selectedDateFrom).format('YYYY-MM-DD'),
			selectedDateTo : !(selectedDateTo) ? null : moment(selectedDateTo).format('YYYY-MM-DD'),
			SessionID : auth.SessionID,
			id:this.state.undoRow.id
		}));
	};

	cancelUndo = () =>{
		this.setState({
			dialogOpenUndo:false
		});
	};


	render() {
		const { classes, settings, auth } = this.props;
		const { JigyoushaIsMaker, JigyoushaIsNohinJigyousha, JigyoushaIs3PL} = auth.user;
		const isMaker = JigyoushaIsMaker && !JigyoushaIsNohinJigyousha && !JigyoushaIs3PL;
		const {
			dateType,selectedDateFrom,selectedDateTo,selections,dialogOpen,dialogOpenUndo
		} = this.state;

		const rows = settings.data;
		const disabled = !(selections.length);



		let mainButtons = [];
		if(!isMaker){
			mainButtons = [
				{type:'SAVE',func:this.handleClickSave,text:"登録",disabled:disabled}
			];
		}


		const clickableColumns = [
			{name:'DenpyoNO',func:this.handleClickSlipNo},
			{name:'SelectionReplaceButton',func:this.handleClickUndo,type:'button',text:'取消'}
		];

		const printDialogOpen = (settings.pdfPath !== undefined);

		const Registered = _.filter(rows,(row)=>{
			return row.isSelectionReplace === "1"
		});


		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>荷受書確認</h2>
					</section>
					<ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
							<Typography className={classes.heading}>抽出条件</Typography>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<FormGroup row>
								<RadioGroup
									aria-label="gender"
									name="gender2"
									value={dateType}
									onChange={this.handleDateTypeChange}
									row
								>
									<FormControlLabel
										value="0"
										control={<Radio />}
										label="出荷日"

									/>
									<FormControlLabel
										value="1"
										control={<Radio />}
										label="納品日"
									/>
									<FormControlLabel
										value="2"
										control={<Radio />}
										label="伝票日付"

									/>
									<FormControlLabel
										value="3"
										control={<Radio />}
										label="取込日"
									/>
								</RadioGroup>
									<DatePicker
										keyboard
										label="開始"
										minDateMessage={"7年前までの日付を入力"}
										maxDateMessage={"10日後までの日付を入力"}
										minDate={new moment().add(-7, 'years')}
										maxDate={new moment().add(10, 'days')}
										value={selectedDateFrom}
										onChange={this.handleDateFromChange}
										onInputChange={this.handleDateFromInputChange}
										format="YYYY/MM/DD"
										className={classes.datePicker}
										invalidDateMessage="日付が正しくありません"
										cancelLabel={"キャンセル"}
									/>
									<div className={classes.fromTo}>-</div>
									<DatePicker
										keyboard
										label="終了"
										minDateMessage={"7年前までの日付を入力"}
										maxDateMessage={"10日後までの日付を入力"}
										minDate={new moment().add(-7, 'years')}
										maxDate={new moment().add(10, 'days')}
										value={selectedDateTo}
										onChange={this.handleDateToChange}
										onInputChange={this.handleDateToInputChange}
										className={classes.datePicker}
										format="YYYY/MM/DD"
										invalidDateMessage="日付が正しくありません"
										cancelLabel={"キャンセル"}
									/>

							</FormGroup>
						</ExpansionPanelDetails>
						<Divider />
						<ExpansionPanelActions>
							<Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup}>
								集計
							</Button>
						</ExpansionPanelActions>
					</ExpansionPanel>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							numberColumns={numberColumns}
							clickableColumns={clickableColumns}
							getSelections={this.handleSelectionChange}
							getSortOrders={this.handleSortOrderChange}
							defaultSorts={[{columnName:'NiukeshoStatusName',direction:'desc'}]}
							isShowSlectionCount={false}
							additionalCountContent={{"text":"登録件数","count":Registered.length}}
							hasSelections={!isMaker}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>選択された伝票が登録済となります</span>}
					okFunction={this.doUpdate}
					closeFunction={this.cancelUpdate}
				/>
				<AlertDialog
					open={dialogOpenUndo}
					title={"確認"}
					text={<span>選択された伝票の登録が取り消されます</span>}
					okFunction={this.doUndo}
					closeFunction={this.cancelUndo}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.consigneeListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ConsigneeList);



// WEBPACK FOOTER //
// ./src/routes/consignee-list/index.js